import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const ViewNotificationIcon = (props: IconProps) => {
  const { color = FORTA_BLUE.primary } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <mask id="mask0_4935_56422" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
        <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4935_56422)">
        <path
          d="M12.9288 2.63848L20.7807 7.32309C21.0038 7.46795 21.1794 7.65865 21.3076 7.89518C21.4358 8.13172 21.5 8.38332 21.5 8.64998V19.1923C21.5 19.6974 21.325 20.125 20.975 20.475C20.625 20.825 20.1974 21 19.6923 21H4.3077C3.80257 21 3.375 20.825 3.025 20.475C2.675 20.125 2.5 19.6974 2.5 19.1923V8.64998C2.5 8.38332 2.56411 8.13172 2.69233 7.89518C2.82053 7.65865 2.99616 7.46795 3.21923 7.32309L11.0711 2.63848C11.3557 2.47438 11.6654 2.39233 12 2.39233C12.3346 2.39233 12.6442 2.47438 12.9288 2.63848ZM12.1538 13.0538L19.8 8.49998L12.1538 3.94613C12.1025 3.91408 12.0513 3.89806 12 3.89806C11.9487 3.89806 11.8974 3.91408 11.8461 3.94613L4.19998 8.49998L11.8461 13.0538C11.8974 13.0859 11.9487 13.1019 12 13.1019C12.0513 13.1019 12.1025 13.0859 12.1538 13.0538ZM11.0711 14.3461L3.99998 10.123V19.1923C3.99998 19.282 4.02883 19.3557 4.08653 19.4134C4.14423 19.4711 4.21795 19.5 4.3077 19.5H19.6923C19.782 19.5 19.8557 19.4711 19.9134 19.4134C19.9711 19.3557 20 19.282 20 19.1923V10.123L12.9288 14.3461C12.6442 14.5102 12.3346 14.5923 12 14.5923C11.6654 14.5923 11.3557 14.5102 11.0711 14.3461Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default ViewNotificationIcon;
